
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from '@/layouts/simple';
import OpenAppHeader from '@/components/common/DownloadApp/OpenAppHeader';
import GroceryLandingControl, { showOpenAppDevice } from '@/components/order/Share/GroceryLandingControl';

import { getOrderWeeebatesLanding, getOrderWeeebatesLandingShare } from '@/api/growth';
import { GetServerSideProps } from 'next';
import Constants from '@/constants/const';

import { getCookie } from '@/utils/cookie';
import { getLoginState } from '@/utils/common/user';
import { isFBRobot, isMobileBrowser, isSayWeeeApp } from '@/utils/common/device';

import Head from 'next/head';
import { getAssetsCdnConfig } from '@weee-fe/module';
import { getHttpReqAwareProps } from '@/utils/http-req-aware-helper';
import InviteeHeader from '@/components/referral/InviteeHeader';
import { defaultBack } from '@/components/common/HeaderNew';
import { useRouter } from 'next/router';

type OrderDetailProps = {
  data: any;
  id: string;
  isLogin: boolean;
  isAutoReceive: boolean;
  isFBRobot: boolean;
  isMobile: boolean;
};

export default function OrderShareLanding(props: OrderDetailProps) {
  const { data, id, isLogin, isFBRobot, isAutoReceive, isMobile } = props;
  const { meta_properties } = data;
  const router = useRouter();

  if (isFBRobot) {
    return (
      <div className="bg-[#fff] h-screen">
        <Head>
          <meta name="format-detection" content="telephone=no" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`${meta_properties?.url}&t=${new Date().getTime()}`} />
          <meta property="og:title" content={meta_properties?.title} key="title" />
          <meta property="og:image" content={meta_properties?.image} />
          <meta property="og:description" content={meta_properties?.description} />
          <meta
            property="fb:app_id"
            content={`${process.env.WEEE_FACEBOOK_APPID || process.env.NEXT_PUBLIC_WEEE_FACEBOOK_APPID}`}
          />
        </Head>
      </div>
    );
  }

  return (
    <Layout
      blockStreamlinedHeader
      headerWrapClassName="bg-surface-100-bg"
      contentClassName="bg-primary-3 box-border min-h-[calc(100vh-48px)]"
      header={
        <InviteeHeader
          showBack={true}
          onShowBack={() => {
            defaultBack(router);
          }}
        />
      }
      headerBottomSlot={
        <>
          {/* 登录用户显示下载APP banner */}
          {showOpenAppDevice() && isLogin && <OpenAppHeader openPath={`weeebates/share/grocery/landing/${id}`} />}
        </>
      }>
      <Head>
        <meta name="format-detection" content="telephone=no" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${meta_properties?.url}&t=${new Date().getTime()}`} />
        <meta property="og:title" content={meta_properties?.title} key="title" />
        <meta property="og:image" content={meta_properties?.image} />
        <meta property="og:description" content={meta_properties?.description} />
        <meta
          property="fb:app_id"
          content={`${process.env.WEEE_FACEBOOK_APPID || process.env.NEXT_PUBLIC_WEEE_FACEBOOK_APPID}`}
        />
      </Head>
      <GroceryLandingControl {...props} />
    </Layout>
  );
}

 const _getServerSideProps: GetServerSideProps = async ctx => {
  const { id, status } = ctx?.query;
  const zip = getCookie(Constants.ZIP_CODE, ctx);
  const isAutoReceive = (status as string) === 'fromLogged' ? 1 : 0;
  const isLogin = getLoginState(ctx);

  if (isFBRobot(ctx)) {
    // for Facebook Crawler
    const shareData = await getOrderWeeebatesLandingShare(
      {
        orderId: id,
        zipcode: zip,
        fromLoginSignup: isAutoReceive
      },
      { ctx }
    );
    if (shareData?.result) {
      return {
        props: {
          data: shareData?.object || {},
          isFBRobot: true
        }
      };
    }
  }

  // normal flow
  const res = await getOrderWeeebatesLanding(
    {
      orderId: id,
      zipcode: zip,
      fromLoginSignup: isAutoReceive
    },
    { ctx }
  );
  if (res?.result) {
    return {
      props: {
        id: id,
        data: res?.object || {},
        isLogin: isLogin,
        isAutoReceive: isAutoReceive,
        isMobile: isMobileBrowser(ctx),
        ...getAssetsCdnConfig(ctx),
        ...getHttpReqAwareProps(ctx)
      }
    };
  }
  if (res.object?.redirectUrl) {
    return {
      redirect: {
        destination: res.object.redirectUrl,
        permanent: false
      }
    };
  }
  return { notFound: true };
};


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/weeebates/share/grocery/landing/[id]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  